export default __webpack_public_path__ + "static/media/table_NPC_En.9a3b2e30.webp";